/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const BotTypedVideoTutorial = ({
  en,
  fr
}: {
  en: { title: string; url: string };
  fr: { title: string; url: string };
}) => {
  const { t, i18n } = useTranslation();
  const [show, setShow] = useState(false);

  return (
    <React.Fragment>
      <div className="md:tw-flex tw-inline-flex tw-items-center tw-gap-3 md:tw-w-max">
        <div
          className="tw-w-16 tw-h-10 tw-bg-gradient-to-l tw-from-zinc-500 tw-to-zinc-900 tw-rounded-[1px] tw-flex tw-flex-col tw-items-center tw-justify-center"
          onClick={() => setShow(true)}
          role="button"
        >
          <svg
            width="40"
            height="40"
            viewBox="0 0 40 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="15" y="13" width="12" height="15" fill="white" />
            <path
              d="M35.9884 12.0047C35.7986 11.3004 35.4276 10.658 34.9123 10.1416C34.3971 9.62524 33.7556 9.25279 33.0517 9.06135C30.4417 8.34469 20.0001 8.33302 20.0001 8.33302C20.0001 8.33302 9.56006 8.32135 6.94839 9.00635C6.24494 9.2066 5.60476 9.58432 5.08934 10.1032C4.57391 10.6222 4.20054 11.2649 4.00506 11.9697C3.31673 14.5797 3.31006 19.993 3.31006 19.993C3.31006 19.993 3.30339 25.433 3.98673 28.0164C4.37006 29.4447 5.49506 30.573 6.92506 30.958C9.56173 31.6747 19.9751 31.6864 19.9751 31.6864C19.9751 31.6864 30.4167 31.698 33.0267 31.0147C33.7309 30.8236 34.373 30.452 34.8895 29.9367C35.406 29.4213 35.779 28.7801 35.9717 28.0764C36.6617 25.468 36.6667 20.0564 36.6667 20.0564C36.6667 20.0564 36.7001 14.6147 35.9884 12.0047V12.0047ZM16.6601 25.008L16.6684 15.008L25.3467 20.0164L16.6601 25.008V25.008Z"
              fill="#E34A51"
            />
          </svg>
        </div>

        <div className="tw-flex-col tw-justify-center tw-items-start tw-gap-1 md:tw-inline-flex tw-hidden">
          <div className="tw-text-zinc-900 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">
            {i18n.language === "en" ? en.title : fr.title}
          </div>
          <div className="tw-text-zinc-900 tw-text-xs tw-font-normal tw-font-['Lexend'] tw-leading-none">
            {t("BotTypedVideoTutorial/key1")}
          </div>
        </div>
      </div>

      <Modal
        size="lg"
        show={show}
        onHide={() => setShow(false)}
        backdrop="static"
        centered
        style={{ maxWidth: "100%" }}
      >
        <Modal.Header closeButton className="tw-border-0 tw-items-start">
          <span className="tw-text-zinc-900 tw-text-xl tw-font-bold tw-font-['Sofia Sans'] tw-items-start tw-justify-between">
            {t("BotTypedVideoTutorial/tutorial")}
          </span>
        </Modal.Header>
        <Modal.Body>
          <iframe
            src={i18n.language === "en" ? en.url : fr.url}
            width="100%"
            className="md:tw-h-[28rem] sm:tw-h-full"
            style={{ border: "none" }}
            title="Tutorial Iframe"
          ></iframe>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};

export default BotTypedVideoTutorial;
